import urlHelper from '../helpers/url'
import { UCL } from '../core/UserClientLibs';

const yaTiene = () => {
    UCL.RefreshAsync().finally(urlHelper.returnBack());
}

export default yaTiene;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/yaTiene.js